import requester from '../utils/requester';
import Platform from '../platform';
import ReactGA from 'react-ga';
import config from '../config';

const initialize = () => {
  ReactGA.initialize(config.gaTrackID, {
    gaOptions: {
      clientId: Platform.getUID(),
    },
    debug: false,
  });
};

const postEvent = (category, action, label = '') => {
  if (Platform.getName() === 'Tizen') {
    const dataJson = {
      v: 1,
      tid: config.gaTrackID,
      cid: Platform.getUID(),
      dl: 'tizen-app',
      t: 'event',
      ec: category,
      ea: action,
      el: label,
    };

    _postGARequest(dataJson);
  } else {
    ReactGA.event({
      category: category,
      action: action,
    });
  }
};
const trackPageView = urlDP => {
  if (Platform.getName() === 'Tizen') {
    const dataJson = {
      v: 1,
      tid: config.gaTrackID,
      cid: Platform.getUID(),
      dl: 'tizen-app',
      t: 'pageview',
      dp: urlDP,
    };

    _postGARequest(dataJson);
  } else {
    ReactGA.set({ page: urlDP }); // Update the user's current page
    ReactGA.pageview(urlDP); // Record a pageview for the given page
  }
};

function _postGARequest(dataJson) {
  const url = 'https://www.google-analytics.com/collect';

  let dataToPOST = '';

  for (let [key, value] of Object.entries(dataJson)) {
    dataToPOST += `${key}=${value}&`;
  }

  try {
    requester({
      method: 'post',
      url: url,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
      appendParams: false,
      data: dataToPOST,
    });
  } catch (error) {
    console.error(error);
  }
}

export default {
  initialize,
  postEvent,
  trackPageView,
};
